import { Formatters } from '../modules'

export default {
  props: {
    name: { label: '姓名', required: true },
    idcard: {
      label: '身份证号',
      required: true,
      classes: (value) => {
        if (!value || value.length !== 18)
          return 'negative hide-in-mobile'
        return 'hide-in-mobile'
      },
    },
    idcard_masked: {
      label: '身份证号',
      formatter: (_, record) => {
        const value = record.idcard
        if (!value || value.length !== 18)
          return value
        return value.slice(0, 6) + '*'.repeat(8) + value.slice(14)
      },
      classes: (_, record) => {
        const value = record.idcard
        if (!value || value.length !== 18)
          return 'negative hide-in-mobile'
        return 'hide-in-mobile'
      },
    },
    rooms: {
      label: '房间',
      formatter(rooms) {
        return (rooms || []).map(r => (r ? this.$store.getters.get_room_no(r.room) : null)).filter(no => no).join(', ')
      },
    },
    phone1: {
      label: '联系电话',
      required: true,
      classes: (value) => {
        if (!value || value.length !== 11)
          return 'negative'
      },
      type: 'phone',
    },
    phone2: {
      label: '第二联系电话',
      classes: 'hide-in-mobile',
      type: 'phone',
    },
    work: {
      label: '工作单位',
    },
    address: {
      label: '身份证地址',
      classes: 'hide-in-tablet',
      maxlength: 25,
    },
    contact: {
      label: '紧急联络人',
      classes: 'hide-in-mobile',
    },
    gender: {
      label: '性别',
      classes: 'hide-in-mobile',
      default: 0,
      formatter: Formatters.gender,
      type: 'select',
      select: [
        { key: 0, label: ' ' },
        { key: 1, label: '男' },
        { key: 2, label: '女' },
      ],
    },
    cards_amount: {
      label: '房卡数量',
    },
    population_recorded: {
      label: '流动人口录入',
      formatter: (value) => (value ? '✔' : ''),
      type: 'check',
      classes: 'center aligned themed text',
    },
    note: {
      label: '备注',
      maxlength: 15,
    },
  },

  actions: {
    edit: {
      icon: 'pencil',
      tooltip: '编辑',
      permissions: 'basic.modify.customers',
    },
    card_checkin: {
      icon: 'add',
      text: '发卡',
      permissions: 'native.cards.checkin',
    },
    card_extension: {
      icon: 'certificate',
      text: '续住',
      permissions: 'native.cards.extension',
    },
    card_supplement: {
      icon: 'asterisk',
      text: '补卡',
      permissions: 'native.cards.supplement',
    },
    card_checkout: {
      icon: 'trash',
      tooltip: '退卡',
      permissions: 'native.cards.checkout',
    },
    kitchen_new: {
      icon: 'fire',
      tooltip: '厨房发卡',
      permissions: 'native.kitchen.new',
    },
    card_extension_custom: {
      icon: 'certificate',
      tooltip: '续住n日',
      permissions: 'native.cards.extension.custom',
    },
  },
  layouts: {
    default: {
      layout: ['name', 'idcard_masked', 'phone1', 'address', 'contact', 'population_recorded'],
    },
    list: {
      layout: ['name', 'rooms', 'phone1', 'idcard_masked', 'address', 'contact', 'population_recorded'],
    },
    detail: {
      layout: ['name', 'idcard', 'phone1', 'phone2', 'gender', 'contact', 'address', 'work', 'note', 'population_recorded'],
    },
  },

  form: {
    create: {
      type: 'post',
      url: 'customers',
      confirm: '确定添加该住户？',
      loadOnSuccess: 'customers',
    },
    modify: {
      type: 'put',
      url() { return `customers/${this.form._id}` },
      confirm: '确定保存修改？',
      loadOnSuccess: 'customers',
    },
    layout: [
      ['name', 'idcard', 'phone1'],
      ['address', 'contact', 'gender'],
      ['note', 'population_recorded'],
    ],
  },

  filters: {
    search: {
      type: 'search',
      keys: [
        '$rooms',
        'phone1',
        'phone2',
        'contact',
        'name',
        'idcard',
        'address',
      ],
    },
    select: {
      type: 'select',
      selects: [{
        name: null,
        label: '全部',
      },
      {
        name: 'checked',
        label: '当前入住',
        filter: (record) => record.rooms,
      },
      {
        name: 'incomplete',
        label: '信息不全',
        filter: (record) => {
          if (!record.rooms)
            return false
          if (!record.idcard || record.idcard.length !== 18)
            return true
          if (!record.phone1 || record.phone1.length !== 11)
            return true
          if (!record.address)
            return true
          return false
        },
      },
      {
        name: 'unrecorded',
        label: '未录入流动人口',
        filter: (record) => {
          if (!record.rooms)
            return false
          if (!record.population_recorded)
            return true
          return false
        },
      },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/customer.js